import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useCoinbaseOnrampOptions(country, visitorData, isLoadingVisitorData) {
  const $ = _c(13);
  let t0;
  let t1;
  if ($[0] !== country || $[1] !== visitorData) {
    t0 = ["getCoinbaseOnrampOptions", country, visitorData];
    t1 = () => anyspendService.getCoinbaseOnrampOptions(country, visitorData);
    $[0] = country;
    $[1] = visitorData;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  const t2 = Boolean(country) && !isLoadingVisitorData;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery(t3);
  let t4;
  const t5 = data?.data;
  let t6;
  if ($[8] !== error || $[9] !== isLoading || $[10] !== refetch || $[11] !== t5) {
    t6 = {
      coinbaseOnrampOptions: t5,
      isLoadingCoinbaseOnrampOptions: isLoading,
      coinbaseOnrampOptionsError: error,
      refetchCoinbaseOnrampOptions: refetch
    };
    $[8] = error;
    $[9] = isLoading;
    $[10] = refetch;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  t4 = t6;
  return t4;
}